/**
 * Typed wrappers around `useDispatch` / `useSelector`.
 *
 * Use `useAppDispatch()` and `useAppSelector()` everywhere instead of the
 * raw `react-redux` hooks so dispatches accept thunks and selectors are
 * narrowed to `RootState`.
 */

import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';

import type { AppDispatch, RootState } from './store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
